var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card-actions', {
    attrs: {
      "action-collapse": "",
      "title": "Setting Marketing"
    }
  }, [_c('p', {
    staticClass: "mb-2 text-body"
  }, [_vm._v(" Tempatkan sales ke mobil sebagai lokasi stok jualan. ")]), _c('b-row', {
    staticClass: "align-items-end mb-1"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Per halaman",
      "label-for": "perPageSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "5",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Cari",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search",
      "placeholder": "Cari data setting marketing..."
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.applySearch($event);
      }
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v(" Clear ")])], 1)], 1)], 1)], 1), _c('b-col', {
    staticClass: "my-1 d-flex justify-content-md-end",
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_vm.allowCreate() ? _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }, {
      name: "b-modal",
      rawName: "v-b-modal.modal-tambah",
      modifiers: {
        "modal-tambah": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Tambah ")], 1) : _vm._e()], 1)], 1), _vm.allowCreate() || _vm.allowUpdate() ? _c('b-modal', {
    attrs: {
      "id": "modal-tambah",
      "cancel-variant": "secondary",
      "centered": "",
      "title": _vm.id ? 'Form Ubah' : 'Form Tambah',
      "hide-footer": ""
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('b-form', [_c('b-form-group', {
    attrs: {
      "label": "Teritori",
      "label-for": "teritory"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "teritory",
      "options": _vm.teritory_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih teritori..."
    },
    model: {
      value: _vm.form.teritory_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "teritory_id", $$v);
      },
      expression: "form.teritory_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Rute",
      "label-for": "rute"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "rute",
      "options": _vm.rutes,
      "multiple": "",
      "label": "text",
      "placeholder": "Pilih rute..."
    },
    model: {
      value: _vm.selectedRutes,
      callback: function callback($$v) {
        _vm.selectedRutes = $$v;
      },
      expression: "selectedRutes"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Kendaraan",
      "label-for": "kendaraan"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "kendaraan",
      "options": _vm.kendaraan_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih kendaraan..."
    },
    model: {
      value: _vm.form.kendaraan_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kendaraan_id", $$v);
      },
      expression: "form.kendaraan_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Sales",
      "label-for": "sales"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "sales",
      "options": _vm.karyawan_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih sales..."
    },
    model: {
      value: _vm.form.karyawan_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "karyawan_id", $$v);
      },
      expression: "form.karyawan_id"
    }
  }), _vm.isAllSalesOut ? _c('strong', {
    staticClass: "d-block text-danger"
  }, [_c('i', [_vm._v("Semua sales sudah ditempatkan")])]) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label": "Driver",
      "label-for": "driver"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "driver",
      "options": _vm.driver_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih driver..."
    },
    model: {
      value: _vm.form.driver_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "driver_id", $$v);
      },
      expression: "form.driver_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Alamat (Opsional)",
      "label-for": "alamat"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "alamat",
      "placeholder": "Isi Alamat"
    },
    model: {
      value: _vm.form.alamat,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "alamat", $$v);
      },
      expression: "form.alamat"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Keterangan (Opsional)",
      "label-for": "keterangan"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "keterangan",
      "placeholder": "Isi Keterangan"
    },
    model: {
      value: _vm.form.keterangan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keterangan", $$v);
      },
      expression: "form.keterangan"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.showModal = false;
      }
    }
  }, [_vm._v(" Batal ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm.saving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.saving ? "Menyimpan..." : _vm.id ? "Ubah" : "Simpan") + " ")], 1)], 1)], 1) : _vm._e(), _vm.allowUpdate() ? _c('b-modal', {
    attrs: {
      "id": "modal-ubah",
      "cancel-variant": "secondary",
      "centered": "",
      "title": "Form Ubah",
      "hide-footer": ""
    },
    model: {
      value: _vm.showModalEdit,
      callback: function callback($$v) {
        _vm.showModalEdit = $$v;
      },
      expression: "showModalEdit"
    }
  }, [_c('b-form', [_c('b-form-group', {
    attrs: {
      "label": "Teritori",
      "label-for": "teritory-edit"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "teritory-edit",
      "options": _vm.teritory_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih teritori..."
    },
    model: {
      value: _vm.form.teritory_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "teritory_id", $$v);
      },
      expression: "form.teritory_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Kendaraan",
      "label-for": "kendaraan-edit"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "kendaraan-edit",
      "options": _vm.kendaraan_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih kendaraan..."
    },
    model: {
      value: _vm.form.kendaraan_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kendaraan_id", $$v);
      },
      expression: "form.kendaraan_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Sales",
      "label-for": "sales-edit"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "sales-edit",
      "options": _vm.karyawan_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih sales..."
    },
    model: {
      value: _vm.form.karyawan_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "karyawan_id", $$v);
      },
      expression: "form.karyawan_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Driver",
      "label-for": "driver-edit"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "driver-edit",
      "options": _vm.driver_id,
      "reduce": function reduce(option) {
        return option.value;
      },
      "label": "text",
      "placeholder": "Pilih driver..."
    },
    model: {
      value: _vm.form.driver_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "driver_id", $$v);
      },
      expression: "form.driver_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Alamat (Opsional)",
      "label-for": "alamat-edit"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "alamat-edit",
      "placeholder": "Isi Alamat"
    },
    model: {
      value: _vm.form.alamat,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "alamat", $$v);
      },
      expression: "form.alamat"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Keterangan (Opsional)",
      "label-for": "keterangan-edit"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "keterangan-edit",
      "placeholder": "Isi Keterangan"
    },
    model: {
      value: _vm.form.keterangan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keterangan", $$v);
      },
      expression: "form.keterangan"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.showModalEdit = false;
      }
    }
  }, [_vm._v(" Batal ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm.saving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.saving ? "Menyimpan..." : "Ubah") + " ")], 1)], 1)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [!_vm.loading && !_vm.items.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada data setting marketing "), _vm.filter ? _c('span', [_vm._v(" untuk pencarian “" + _vm._s(_vm.filter) + "”")]) : _vm._e(), _vm._v(". ")]) : _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields,
      "show-empty": "",
      "empty-text": "Tidak ada data"
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + row.index + 1) + " ")])];
      }
    }, {
      key: "cell(teritori)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', [_c('strong', [_vm._v(" " + _vm._s(item.teritori && item.teritori.nama_teritori ? item.teritori.nama_teritori : "-") + " ")]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" Kendaraan: " + _vm._s(item.kendaraan ? [item.kendaraan.nama_kendaraan, item.kendaraan.plat_nomer].filter(Boolean).join(" · ") || "-" : "-") + " ")])])];
      }
    }, {
      key: "cell(info_sales)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('div', [_c('strong', [_vm._v(" " + _vm._s(item.karyawan && item.karyawan.nama_lengkap ? item.karyawan.nama_lengkap : "-") + " ")]), _c('small', {
          staticClass: "d-block text-muted"
        }, [_vm._v(" Driver: " + _vm._s(item.driver && item.driver.nama_lengkap ? item.driver.nama_lengkap : "-") + " ")])])];
      }
    }, {
      key: "cell(rute_sales)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.rute_sales && item.rute_sales.length ? _c('ul', {
          staticClass: "mb-0 pl-1"
        }, _vm._l(item.rute_sales, function (rute, idx) {
          return _c('li', {
            key: "".concat(item.id, "-rute-").concat(idx)
          }, [_vm._v(" " + _vm._s(rute) + " ")]);
        }), 0) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "cell(keterangan)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.keterangan || "-") + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(row) {
        return [_vm.allowUpdate() ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Ubah',
            expression: "'Ubah'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-50",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        })], 1) : _vm._e(), _vm.allowDelete() ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Hapus',
            expression: "'Hapus'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        })], 1) : _vm._e()];
      }
    }])
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-between align-items-center mt-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Total " + _vm._s(_vm.totalRows) + " data ")]), _c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }